// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.persona.RentalManagerUserPropertyPersonaLinkWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink,
  RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, RentalManagerGetPersonaLinkResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

interface GetLinkParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Options = UseQueryOptions<
  RentalManagerGetPersonaLinkResponseDto,
  unknown,
  RentalManagerGetPersonaLinkResponseDto,
  Array<string | GetLinkParams>
>;

const RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_GetKey = (getParams: GetLinkParams) => [
  RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Path,
  getParams,
];

/**
 * Get persona inquiry link for a listing
 */
export const useRentalManagerUserPropertyPersonaLinkWebApiHandler_getLink = (
  getParams: GetLinkParams,
  options: Omit<RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink(getParams),
  });
};
useRentalManagerUserPropertyPersonaLinkWebApiHandler_getLink.getKey =
  RentalManagerUserPropertyPersonaLinkWebApiHandler_getLink_GetKey;
